// Dates des posts du hub You. en-GB rend "Sept" pour septembre depuis les ICU
// recents : on coupe le mois a trois lettres pour que toutes les cartes aient
// la meme longueur de meta. hourCycle h23 evite "24:00" a minuit.
const parse = (iso) => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

const dayParts = (date, timeZone) => {
  const options = { weekday: 'short', day: 'numeric', month: 'short' };
  if (timeZone) options.timeZone = timeZone;
  const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || '';
  return { weekday: get('weekday'), day: get('day'), month: get('month').slice(0, 3) };
};

const timeOf = (date, timeZone) => {
  const options = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
  if (timeZone) options.timeZone = timeZone;
  return new Intl.DateTimeFormat('en-GB', options).format(date);
};

export function formatWhen(iso, { timeZone } = {}) {
  const date = parse(iso);
  if (!date) return '';
  const { weekday, day, month } = dayParts(date, timeZone);
  return `${weekday} ${day} ${month}, ${timeOf(date, timeZone)}`;
}

export function formatDay(iso, { timeZone } = {}) {
  const date = parse(iso);
  if (!date) return '';
  const { day, month } = dayParts(date, timeZone);
  return `${day} ${month}`;
}

const stamp = (iso) => {
  const date = parse(iso);
  return date ? date.getTime() : null;
};

export function isLiveNow(post) {
  if (!post || post.type !== 'live') return false;
  const starts = stamp(post.starts_at);
  return starts === null || starts > Date.now();
}

// Les dates arrivent en ISO avec des decalages differents : on compare des
// instants, jamais des chaines.
export function isUnread(post, seenBefore) {
  const seen = stamp(seenBefore);
  if (seen === null) return true;
  const published = stamp(post?.published_at);
  return published === null ? false : published > seen;
}

export function postMeta(post) {
  if (!post) return '';
  if (post.type === 'live' && post.starts_at) return formatWhen(post.starts_at);
  if (post.type === 'release') {
    const day = formatDay(post.published_at);
    if (post.version && day) return `Version ${post.version} · ${day}`;
    if (post.version) return `Version ${post.version}`;
    return day;
  }
  return formatDay(post.published_at);
}
